import {
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { ArrowUp } from "./arrow";

const commonTdStyles = {
  px: {
    base: "2",
    md: "6",
  },
  py: {
    base: "0.1em",
    md: "4",
  },
  fontSize: {
    base: "xs",
    md: "md",
  },
};

export const RiskTable = () => (
  <HStack
    sx={{
      ".caption": {
        fontSize: {
          base: "2xs",
          md: "sm",
        },
      },

      ".explainer": {
        display: {
          base: "none",
          md: "inline-flex",
        },
      },
    }}
  >
    <HStack justifyContent="space-around" className="explainer">
      <TableContainer>
        <Table
          border="none"
          sx={{
            td: {
              fontWeight: "semibold",
              textAlign: "right",
              border: "none",
              ...commonTdStyles,
              pr: 0,
            },
          }}
        >
          <Thead>
            <Th />
          </Thead>
          <Tbody>
            <Tr>
              <Td color="orange.600">Expected Annual Loss</Td>
            </Tr>
            <Tr>
              <Td color="green.600">Social Vulnerability</Td>
            </Tr>
            <Tr>
              <Td></Td>
            </Tr>
            <Tr>
              <Td className="caption">
                Higher Expected Annual <br />
                Loss & Social Vulnerability <br /> = Higher Risk
              </Td>
            </Tr>
            <Tr>
              <Td></Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
      <ArrowUp h="300px" color="blueGray.300" />
    </HStack>
    <TableContainer
      borderRadius="lg"
      border="1px solid"
      boxShadow="sm"
      borderColor="blueGray.200"
    >
      <Table
        variant="simple"
        sx={{
          "th,td": {
            borderBottom: "1px solid",
            borderBottomColor: "blueGray.200",
            fontWeight: "semibold",

            ...commonTdStyles,
          },
        }}
      >
        <Thead>
          <Tr>
            <Th />
            <Th />
            <Th textAlign="center">Rating Category</Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td bg="orange.700" />
            <Td bg="green.700" />
            <Td textAlign="center">Very High</Td>
            <Td bg="purple.700" />
          </Tr>
          <Tr>
            <Td bg="orange.500" />
            <Td bg="green.500" />
            <Td textAlign="center">Relatively High</Td>
            <Td bg="purple.500" />
          </Tr>
          <Tr>
            <Td bg="orange.400" />
            <Td bg="green.400" />
            <Td textAlign="center">Relatively Moderate</Td>
            <Td bg="purple.400" />
          </Tr>
          <Tr>
            <Td bg="orange.200" />
            <Td bg="green.200" />
            <Td textAlign="center">Relatively Low</Td>
            <Td bg="purple.200" />
          </Tr>
          <Tr>
            <Td bg="orange.100" />
            <Td bg="green.100" />
            <Td textAlign="center">Very Low</Td>
            <Td bg="purple.100" />
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
    <HStack justifyContent="space-around" className="explainer">
      <ArrowUp h="300px" transform="rotate(180deg)" color="blueGray.300" />
      <TableContainer>
        <Table
          border="none"
          sx={{
            td: {
              fontWeight: "semibold",
              textAlign: "left",
              border: "none",
              ...commonTdStyles,
              pl: 0,
            },
          }}
        >
          <Thead>
            <Th />
          </Thead>
          <Tbody>
            <Tr>
              <Td color="purple.500">Community Resilience</Td>
            </Tr>
            <Tr>
              <Td />
            </Tr>
            <Tr>
              <Td></Td>
            </Tr>
            <Tr>
              <Td className="caption">
                Lower Community Resilience <br /> = Higher Risk
              </Td>
            </Tr>
            <Tr>
              <Td></Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </HStack>
  </HStack>
);
